(ns hai.ui.components.page-not-found
  (:require
   [lambdaisland.ornament :as o]
   #?(:clj [garden.stylesheet :as gs])
   [reagent.core :as r])
  #?(:cljs
     ;; Ensure the clj namespace is initialized, because we use clojure.core/str
     ;; calls inside the CSS portion
     (:require-macros hai.ui.components.page-not-found)))

(def not-found-messages
  ["We asked our AI where this page went. It shrugged. 🤷"
   "404: The page you seek has gone on a digital vacation 🏖️"
   "Oopsie daisy! This page wandered off to find itself. 🌻"
   "This page is playing hide and seek. It's really good at hiding! 🙈"
   "Our hamsters stopped running. The page got lost in the tubes. 🐹"
   "Plot twist: The page you're looking for doesn't exist... yet! 🎬"
   "This page took a wrong turn at the internet intersection 🚦"
   "404 hugs! The page ran away but left this message for you 🤗"
   "The pixels for this page are still in the mail. Check back later! 📮"
   "This page is in another castle! Try a different URL, Mario! 🏰"])

#?(:clj
   (o/defrules balloon-animation
     (gs/at-keyframes
      :floatBalloon
      [:0% {:bottom "100px"
            :opacity "1"
            :transform "translateX(-50%) translateY(0) rotate(-5deg)"}]
      [:25% {:transform "translateX(-20%) translateY(-25vh) rotate(5deg)"}]
      [:50% {:transform "translateX(90%) translateY(-50vh) rotate(-3deg)"}]
      [:75% {:transform "translateX(10%) translateY(-75vh) rotate(3deg)"}]
      [:90% {:opacity "1"
             :transform "translateX(-50%) translateY(-90vh) rotate(-2deg)"}]
      [:100% {:bottom "100vh"
              :opacity "0"
              :transform "translateX(-50%) translateY(-100vh) rotate(0deg)"}])))

(o/defstyled balloon :div
  :absolute :bottom-0
  :w-12 :h-16
  {:animation "floatBalloon 16s ease-out forwards"
   :pointer-events "none"
   :z-index "1000"}

  [:.balloon-body
   :w-12 :h-14 :rounded-full
   :relative :overflow-hidden
   {:box-shadow "inset -5px -10px 0 rgba(0,0,0,0.1)"}

   [:&:before
    :absolute :top-2 :left-2
    :w-4 :h-6 :bg-white :rounded-full
    {:content "\"\""
     :opacity "0.3"
     :transform "rotate(-20deg)"}]]

  [:.balloon-string
   :w-px :h-20 :bg-gray-400
   :mx-auto :-mt-1
   {:transform-origin "top"}]
  ([{:keys [x-position color]}]
   [:<> {:style {:left x-position}}
    [:div.balloon-body {:style {:background-color color}}]
    [:div.balloon-string]]
   )
  )

#?(:cljs
   (o/defstyled full-page :div
     :flex :flex-col :items-center :justify-center
     :min-h-screen :p-8 :text-center
     :bg-gradient-to-br :from-gray-50 :to-gray-100
     [:&.dark-theme :from-gray-900 :to-gray-800]

     [:.not-found-container
      :bg-white :rounded-2xl :shadow-2xl :p-12 :max-w-2xl :w-full
      :border :border-gray-100
      [:&.dark-theme :bg-gray-800 :border-gray-700]]

     [:.error-code
      :text-9xl :font-black :bg-gradient-to-r :from-blue-400 :to-purple-600
      :bg-clip-text :text-transparent :mb-4
      :animate-pulse]

     [:.error-title
      :text-3xl :font-bold :text-gray-800 :mb-4
      [:&.dark-theme :text-gray-200]]

     [:.error-message
      :text-xl :text-gray-600 :mb-8
      [:&.dark-theme :text-gray-400]]

     [:.action-buttons
      :flex :gap-4 :justify-center :flex-wrap]

     [:.home-button
      :px-6 :py-3 :bg-gradient-to-r :from-blue-500 :to-purple-500
      :text-white :rounded-lg :font-semibold :shadow-lg
      :transform :transition-all :duration-200
      :hover:scale-105 :hover:shadow-xl
      :active:scale-95]

     [:.back-button
      :px-6 :py-3 :bg-gray-200 :text-gray-800 :rounded-lg :font-semibold
      :transform :transition-all :duration-200
      :hover:bg-gray-300 :hover:scale-105
      [:&.dark-theme :bg-gray-700 :text-gray-200 :hover:bg-gray-600]]

     [:.decoration
      :absolute :opacity-10
      [:&.circle-1 :w-64 :h-64 :bg-blue-400 :rounded-full :top-10 :left-10 :blur-3xl]
      [:&.circle-2 :w-96 :h-96 :bg-purple-400 :rounded-full :bottom-10 :right-10 :blur-3xl]]

     [:.celebrate-hint
      :mt-8 :text-sm :text-gray-500
      [:&.dark-theme :text-gray-400]]

     [:.balloon-btn :underline :cursor-pointer :hover:text-blue-500 :transition-colors]

     ([{:keys [dark-theme? home-url back!]}]
      (r/with-let [!show (r/atom false)
                   _ (js/setTimeout #(reset! !show true) 500)
                   !balloons (r/atom [])
                   balloon-colors ["#EF4444" "#F59E0B" "#10B981" "#3B82F6" "#8B5CF6" "#EC4899" "#06B6D4"]
                   launch-balloon! (fn []
                                     (let [balloon-data {:id (random-uuid)
                                                         :x-position (str (rand-int 90) "%")
                                                         :color (rand-nth balloon-colors)}]
                                       (swap! !balloons conj balloon-data)
                                       (js/setTimeout
                                        #(swap! !balloons (fn [balloons]
                                                            (vec (remove (fn [item] (= (:id item) (:id balloon-data))) balloons))))
                                        16000)))]
        (when @!show
          [:<> {:class (when dark-theme? "dark-theme")}
           [:div.decoration.circle-1]
           [:div.decoration.circle-2]
           [:div.not-found-container {:class (when dark-theme? "dark-theme")}
            [:div.error-code "404"]
            [:div.error-title {:class (when dark-theme? "dark-theme")}
             "Oops! Page Not Found"]
            [:div.error-message {:class (when dark-theme? "dark-theme")}
             (rand-nth not-found-messages)]
            [:div.action-buttons
             [:a.home-button {:href home-url}
              "Go to Home"]
             [:button.back-button
              {:class (when dark-theme? "dark-theme")
               :on-click back!}
              "Go Back"]]
            [:div.celebrate-hint
             {:class (when dark-theme? "dark-theme")}
             "Feeling lost? "
             [:button.balloon-btn
              {:on-click launch-balloon!
               :class ""}
              "Send a balloon for help! 🎈"]]
            (doall
             (for [balloon-data @!balloons]
               ^{:key (:id balloon-data)} [balloon balloon-data]))]])))))
